export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[620px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/8 via-background-50/40 to-accent-500/8"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-5 tracking-wide">
              最新热门 · 每日更新
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              丫丫影院 - 免费高清影视在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading mb-6">
              全网热播剧集、院线大片，无需付费注册，打开即看
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              丫丫影院汇集海量免费电视剧全集与电影大全，覆盖国产剧、韩剧、美剧、日剧及最新院线影片。每日同步更新热门剧集，高清画质流畅不缓冲，无需注册登录即可免费在线观看全集。无论是最新上线的热播剧还是经典老片，丫丫影院都能满足您的追剧需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">同步热播</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">高清流畅</div>
                <div className="text-xs text-foreground-500 mt-1">不缓冲不卡顿</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                立即免费观看
              </a>
              <a
                href="#ranking"
                className="px-8 py-3 border-2 border-primary-300 text-primary-600 font-medium rounded-full hover:bg-primary-50 transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                查看热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20aesthetic%20with%20warm%20crimson%20red%20and%20gold%20accents%2C%20abstract%20film%20reel%20textures%20floating%20in%20soft%20dramatic%20lighting%2C%20elegant%20curved%20shapes%20suggesting%20cinema%20curtains%2C%20dark%20and%20warm%20atmosphere%20with%20golden%20highlights%2C%20minimalist%20composition%2C%20premium%20entertainment%20brand%20visual%2C%20no%20text%20no%20people&width=700&height=525&seq=hero-visual-yaya-01&orientation=landscape"
                alt="丫丫影院主视觉 - 免费高清影视在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}